import { render } from "./PointLists.vue?vue&type=template&id=79b728d7&scoped=true"
import script from "./PointLists.vue?vue&type=script&lang=js"
export * from "./PointLists.vue?vue&type=script&lang=js"

import "./PointLists.vue?vue&type=style&index=0&id=79b728d7&lang=scss&scoped=true"

import exportComponent from "/var/www/test.adx-co.jp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b728d7"]])

export default __exports__